var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-product-variations",
      class: { "is-loading": _vm.isLoading },
    },
    _vm._l(_vm.productVariations, function (productVariation) {
      return _c(
        "div",
        { key: productVariation.id, staticClass: "c-product-variations__item" },
        [
          _c("div", { staticClass: "c-product-variations__title" }, [
            _c("span", { staticClass: "sc-text" }, [
              _vm._v(_vm._s(productVariation.name)),
            ]),
            _vm._v(" "),
            productVariation.id == 4
              ? _c("span", { staticClass: "sc-value" }, [
                  _vm._v(_vm._s(productVariation.selected.name)),
                ])
              : _vm._e(),
            _vm._v(" "),
            productVariation.custom_tooltip
              ? _c("i", {
                  staticClass: "ico ico-question-circle js-tippy",
                  attrs: {
                    "data-tippy-content": productVariation.custom_tooltip,
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-product-variations__content",
              class: _vm.getContentClass(productVariation),
            },
            [
              _vm._l(
                _vm.getSortedVariationValues(productVariation.variation_values),
                function (variationValue, index) {
                  return [
                    _vm.isImageSelect(productVariation) && variationValue.image
                      ? [
                          _c(
                            "button",
                            {
                              key: variationValue.id,
                              staticClass:
                                "c-product-variations__button c-product-variations__button--image js-tippy-variation",
                              class: {
                                ..._vm.selectButtonClass(variationValue, index),
                                ...{
                                  "js-tippy-destroy":
                                    _vm.checkAvailability(
                                      productVariation.id,
                                      variationValue.id
                                    ) == "enabled",
                                },
                              },
                              attrs: {
                                "data-tippy-content":
                                  _vm.checkAvailability(
                                    productVariation.id,
                                    variationValue.id
                                  ) == "enabled"
                                    ? _vm.imageTippyContent(variationValue)
                                    : _vm.unavailableTippyText(
                                        variationValue.name
                                      ),
                                "data-disabled": _vm.checkAvailability(
                                  productVariation.id,
                                  variationValue.id
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.checkAvailability(
                                    productVariation.id,
                                    variationValue.id
                                  ) == "enabled"
                                    ? _vm.selectVariationValue(variationValue)
                                    : false
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "c-img",
                                attrs: {
                                  src: _vm.thumbnail(
                                    variationValue.image,
                                    "xs"
                                  ),
                                  alt: variationValue.name,
                                },
                              }),
                              _vm._v(" "),
                              variationValue.custom_price
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "c-product-variations__button--price mobile-is-visible",
                                    },
                                    [
                                      _vm._v(
                                        "+" +
                                          _vm._s(
                                            _vm.formatPrice(
                                              variationValue.custom_price
                                            )
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getDiscount(variationValue) > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "c-product-variations__button--price is-discount",
                                    },
                                    [
                                      _vm._v(
                                        "-" +
                                          _vm._s(
                                            _vm.getDiscount(variationValue)
                                          ) +
                                          "%"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "button",
                            {
                              key: variationValue.id,
                              staticClass:
                                "c-product-variations__button c-product-variations__button--text",
                              class: {
                                ..._vm.selectButtonClass(variationValue, index),
                                ...{
                                  "js-tippy-variation":
                                    _vm.checkAvailability(
                                      productVariation.id,
                                      variationValue.id
                                    ) == "disabled",
                                  "js-tippy-destroy":
                                    _vm.checkAvailability(
                                      productVariation.id,
                                      variationValue.id
                                    ) == "enabled",
                                },
                              },
                              attrs: {
                                "data-tippy-content": _vm.unavailableTippyText(
                                  variationValue.name
                                ),
                                "data-disabled": _vm.checkAvailability(
                                  productVariation.id,
                                  variationValue.id
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.checkAvailability(
                                    productVariation.id,
                                    variationValue.id
                                  ) == "enabled"
                                    ? _vm.selectVariationValue(variationValue)
                                    : false
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "c-text" }, [
                                _vm._v(_vm._s(variationValue.name)),
                              ]),
                              _vm._v(" "),
                              variationValue.custom_price
                                ? _c("span", { staticClass: "c-price" }, [
                                    _vm._v(
                                      "+" +
                                        _vm._s(
                                          _vm.formatPrice(
                                            variationValue.custom_price
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                  ]
                }
              ),
              _vm._v(" "),
              false
                ? _c(
                    "button",
                    {
                      staticClass:
                        "c-product-variations__button c-product-variations__button--more",
                      class: _vm.expandMoreClass(productVariation),
                      on: {
                        click: function ($event) {
                          return _vm.expandMore(productVariation.id)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "is-aspect-ratio-fix",
                        attrs: {
                          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "is-content" }, [
                        _c("span", { staticClass: "cxs-is-hidden" }, [
                          _vm._v(
                            "+" +
                              _vm._s(
                                Object.values(productVariation.variation_values)
                                  .length -
                                  _vm.getItemsToShow(
                                    productVariation,
                                    "desktop"
                                  )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cxs-is-visible" }, [
                          _vm._v(
                            "+" +
                              _vm._s(
                                Object.values(productVariation.variation_values)
                                  .length -
                                  _vm.getItemsToShow(productVariation, "phone")
                              )
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }